import React from "react";

import { siteLocationPrefix } from "../../constants";
import { Programs } from "../../models/programsConfig";
import { TestButton } from "./TestButton";
import { TestInput } from "./TestInput";
import * as styles from "./TestStyle.module.css";

type TestIDXboxActionsProps = Readonly<{
  email: string;
}>;

export const TestIDXboxActions = ({ email }: TestIDXboxActionsProps) => (
  <div className={styles.idxboxActionsWrapper}>
    <h3>ID@Xbox Actions</h3>
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/passOneVet`}
      title="Pass OneVet validation"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/nda/sendNdaIdXbox?onboardinguserid=${email}`}
      title="Send NDA (/sendNdaIdXbox endpoint)"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/signNda`}
      title="Force sign NDA"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/createToken`}
      title="Set a mock Partner Center token"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/createToken?reset=reset`}
      title="Reset token"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/approveGameConcept`}
      title="Approve Game Concept"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/signGameConceptContracts`}
      title="Sign Game Concept TLA contract"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/setGdkReceived`}
      title="Sign GDK contract"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/setGameConceptTlaAndGdk`}
      title="Approve concept + sign TLA + sign GDK"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/setSellerId`}
      label="Seller Id "
      buttonText="change"
      actionName="sellerId"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/setFastTrack`}
      title="Make account Fast-Track"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/setFastTrack?reset=reset`}
      title="Remove Fast-Track"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/nda/checkSignature?onboardinguserid=${email}`}
      title="Check NDA signature and mark it on CRM (/checkSignature endpoint)"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/nda/reSendNdaIdXbox?onboardinguserid=${email}`}
      title="Re-send NDA (/reSendNdaIdXbox), gaming_sendnewnda must be 751650000"
    />
    <br />
    <br />
  </div>
);
